import ExternalLawyersPage from '@/views/external-lawyers'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/external-lawyers/')({
  component: ExternalLawyersPage,
})
